import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Axios from 'axios';


const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState(''); 
  
  const handleResetPassword = async (event) => {
    event.preventDefault();

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.'); 
      setSuccessMessage('');
      return;
    }
    try {
      const response = await Axios.post('https://dayoffice24.it/api/forget-password', {
        email: email,
      });

      if (response.data.success) {
        setError('');
        setSuccessMessage('Please check your email for further instructions.');
        setEmail('');
       
      } else {
        setError(response.data.message);
        setSuccessMessage('');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
      setSuccessMessage('');
    }
  };

  return (
    <div className="main_wrap">
      <Header />
      <div className="content-wrapper">
        <section className="property-details-wrap pt-75 pb-75">
          <div className="container">
            <div className="row align-items-center justify-content-center gx-5">
              <div className="col-md-6">
                <div className="login-content">
                  <h2>Forgot Password?</h2>
                  <form className="user-form" onSubmit={handleResetPassword} action="#">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Email Address"
                            required=""
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <button className="btn style1">Send</button>
                        </div>
                      </div>
                    </div>
                  </form>
                  {error && <p className="text-danger">{error}</p>}
                  {successMessage && <p className="text-success">{successMessage}</p>}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;

